import { Injectable } from "@angular/core";
import { Observable, switchMap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { AuthenticationService } from "./authentication.service";
import { CustomerInterface } from "../interfaces/customer.interface";

@Injectable({
  providedIn: "root",
})
export class CustomerService {
  constructor(
    private authService: AuthenticationService,
    private httpClient: HttpClient
  ) {}

  getCustomer(): Observable<CustomerInterface> {
    return this.authService.getAuthenticatedUser$().pipe(
      switchMap(user => {
        if (!user) {
          return Promise.reject("unauthorized user");
        }
        return this.httpClient.get<CustomerInterface>(
          environment.baseURL +
            `customer/${user.customerNO}/${user.custHomeYard}`
        );
      })
    );
  }

  getCustomerTerms(): Observable<
    Array<{
      key: string;
    }>
  > {
    return this.authService.getAuthenticatedUser$().pipe(
      switchMap(user => {
        if (!user) {
          return Promise.reject("unauthorized user");
        }
        return this.httpClient.get<any[]>(
          environment.baseURL + `terms/${user.customerNO}/${user.custHomeYard}`
        );
      })
    );
  }
}
